export default "__VITE_ASSET__f718915f__"